<template>
  <div style="padding:14px 10px">
    <el-form :inline="true" :model="params" class="user-search">
      <el-select size="small" v-model="params.country" clearable placeholder="Country"
        style="width:140px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in countryList" :key="item.name" :label="item.name" :value="item.name">
        </el-option>
      </el-select>
      <el-form-item label="">
        <el-input size="small" v-model="params.rob_user_name" placeholder="Rob user" clearable style="width:140px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker v-model="params.success_time" type="daterange" size="small" value-format="yyyy-MM-dd"
          align="right" unlink-panels start-placeholder="Start Date" end-placeholder="End Date"
          :picker-options="pickerOptions" clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="Loading..."
      style="width: 882px">
      <el-table-column prop="rob_user_name" label="Name" width="120">
      </el-table-column>
      <el-table-column prop="reward" label="Reward amount" width="120">
      </el-table-column>
      <el-table-column prop="count" label="Completed quantity" width="160">
      </el-table-column>
      <el-table-column prop="eve_pay_time" label="Average processing time" width="240">
        <template slot-scope="scope">
          <div>{{ scope.row.eve_pay_time | timeCal }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="pay_time" label="Total processing time" width="240">
        <template slot-scope="scope">
          <div>{{ scope.row.pay_time | timeCal }}</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  smsTransReward, countryList,
} from '../../api/apiFun'
import {
  timestampToTime,
} from '@/utils/util';
export default {
  data() {
    return {
      countryList: [],
      loading: false, //是显示加载
      params: {
        country:'',
        rob_user_name: '',
        success_time: '',
      },
      pickerOptions: {
        shortcuts: [{
          text: 'Today',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last week',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last month',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      listData: [], //User数据
    }
  },
  filters: {
    timestampToTime: function (timestamp) {
      return timestampToTime(timestamp)
    },
    timeCal: function (runTime) {
      let day = Math.floor(runTime / 86400);
      runTime = runTime % 86400;
      let hour = Math.floor(runTime / 3600);
      runTime = runTime % 3600;
      let minute = Math.floor(runTime / 60);
      runTime = runTime % 60;
      let second = runTime;
      let str = '';
      if (day > 0) {
        str += day + ' days ';
      }
      if (hour > 0) {
        str += hour + ' hours ';
      }
      if (minute > 0) {
        str += minute + ' minutes ';
      }
      if (second > 0) {
        str += second + ' seconds ';
      }
      return str;
    }
  },
  created() {
    this.getCountryList()
    this.getdata(this.params)
  },
  methods: {
    getCountryList() {
      countryList().then(res => {
        if (res.code == 400) {
          this.$message({
            state: 'info',
            message: res.msg
          })
        } else {
          this.countryList = res.datas
        }
      }).catch(err => {
        this.$message.error('Failed to get country, please try again later!')
      })
    },
    // 获取WithdrawReward
    getdata(parameter) {
      if (parameter.success_time == null) {
        parameter.success_time = ''
      }
      this.loading = true
      smsTransReward(parameter).then(res => {
        this.loading = false
        if (res.code == 400) {
          this.$message({
            state: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.datas.list
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('Failed to get the withdraw reward, please try again later!')
      })
    },
    // Search事件
    search() {
      this.getdata(this.params)
    },
  }
}

</script>

<style scoped>
.el-image__error {
  font-size: 12px !important;
}

.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/sms/sms_trans_reward.vue